function init(){
const classes = {
	buttonClass: 'info__policy-button',
	wrapperClass: 'info__policy-wrapper',
}
const body = document.body;
const infoForm = document.getElementsByClassName('info__form')[0];
const sendPolicyForm = document.getElementsByClassName('info__policy-form')[0];
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const mores = {
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const anchorActions = {
	openModal: ({ openModal }) => {
		closeAllMenus();
		showModalById(openModal);
	},
}
const buttonActions = {
	downloadPolicy: ({ downloadPolicy }) => {
		if (downloadPolicy) {
			window.open(downloadPolicy, "_blank") || window.location.replace(downloadPolicy);
		}
	},
	sendPolicy: ({ sendPolicy }) => {
		if (!sendPolicy) {
			return;
			// window.open(downloadPolicy, "_blank") || window.location.replace(downloadPolicy);
		}

		sendRequestAndSaveToken('/api/send_policy', {
			method: 'POST', body: JSON.stringify({ token: sendPolicy })
		}).then(({ response }) => {
			if (!response || !response.success) {
				showModalById('error-modal');

				return;
			}

			showModalById('success-modal');
			console.log(response);
		}).catch(e => {
			showModalById('error-modal');
			console.error(e.message);
		})
	},
}
const hideInfoFormInputSuccess = hideSuccess({ groupClass: 'info__form-group' });
const hideInfoFormInputError = hideError({ groupClass: 'info__form-group' });
const hideSendFormInputError = hideError({ groupClass: 'info__policy-form-group' });
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// ]);

for (const prop in menus) {
	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

setCooperateFormHandlers();
setToDirectorFormHandlers();
setIntroFormHandlers();
setInfoFormHandlers();
setSendPolicyFormHandlers();
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
// setLanguagesAndLinks([
// 	...document.getElementsByClassName('header__language-list'),
// 	...document.getElementsByClassName('footer__language-list'),
// ]);
loadGoogleAnalytics();
body.addEventListener('click', (e) => {
	const { target } = e

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
body.addEventListener('click', createButtonClickHandler(buttonActions));
body.addEventListener('click', createAnchorClickHandler(anchorActions));
const setCountryCode = (country) => {
	intlTelInput(document.getElementById('cooperate_phone'), {
		autoHideDialCode: false,
		autoPlaceholder: 'aggressive',
		initialCountry: 'auto',
		separateDialCode: true,
		formatOnDisplay: false,
		preferredCountries: [
			'ua',
			'us'
		],
		customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
			return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
		},
		geoIpLookup: cb => cb(country),
	});
	intlTelInput(document.getElementById('to_director_phone'), {
		autoHideDialCode: false,
		autoPlaceholder: 'aggressive',
		initialCountry: 'auto',
		separateDialCode: true,
		formatOnDisplay: false,
		preferredCountries: [
			'ua',
			'us'
		],
		customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
			return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
		},
		geoIpLookup: cb => cb(country),
	});
}

getCountryCode().then(setCountryCode);
// sendRequest('https://ipapi.co/json')
// 	.then((res) => res.json())
// 	.then(({ country_code }) => {
// 		setCountryCode(country_code || 'us')
// 	})
// 	.catch(e => {
// 		setCountryCode('us')
// 	});

function createDetailsTables (details) {
	const [tableOne, tableTwo] = (new Array(2)).fill(0)
		.map(_ => document.createElement('table'));
	const [tbodyOne, tbodyTwo] = (new Array(2)).fill(0)
		.map(_ => document.createElement('tbody'));
	const [trStart, trEnd, trStatus, trInsuranceStatus, trProgram, trCost, trDays, trName, trLastname,] = (new Array(9)).fill(0).map(_ => document.createElement('tr'));
	const [tdStartLabel, tdStart, tdEndLabel, tdEnd, tdStatusLabel, tdStatus, tdInsuranceStatusLabel, tdInsuranceStatus, tdProgramLabel, tdProgram, tdCostLabel, tdCost, tdDaysLabel, tdDays, tdNameLabel, tdName, tdLastnameLabel, tdLastname,] = (new Array(18)).fill(0).map(_ => document.createElement('td'));

	tdStartLabel.textContent = labels.start;
	tdStart.textContent = details.start;
	trStart.append(tdStartLabel, tdStart);
	tdEndLabel.textContent = labels.end;
	tdEnd.textContent = details.end;
	trEnd.append(tdEndLabel, tdEnd);
	tdStatusLabel.textContent = labels.status;
	tdStatus.appendChild(createStatusSpan(details.status));
	trStatus.append(tdStatusLabel, tdStatus);
	tdInsuranceStatusLabel.textContent = labels.insuranceStatus;
	tdInsuranceStatus.appendChild(createStatusSpan(details.insurance_status));
	trInsuranceStatus.append(tdInsuranceStatusLabel, tdInsuranceStatus);
	tdProgramLabel.textContent = labels.program;
	tdProgram.textContent = getProgramNameById(details.program).toUpperCase();
	trProgram.append(tdProgramLabel, tdProgram);
	tbodyOne.append(trStart, trEnd, trStatus, trInsuranceStatus, trProgram);
	tableOne.append(tbodyOne);
	tdCostLabel.textContent = labels.cost;
	tdCost.textContent = `${details.price} ${details.currency}`;
	trCost.append(tdCostLabel, tdCost);
	tdDaysLabel.textContent = labels.days;
	tdDays.textContent = details.days;
	trDays.append(tdDaysLabel, tdDays);
	tdNameLabel.textContent = labels.name;
	tdName.textContent = details.name;
	trName.append(tdNameLabel, tdName);
	tdLastnameLabel.textContent = labels.lastname;
	tdLastname.textContent = details.lastname;
	trLastname.append(tdLastnameLabel, tdLastname);
	tbodyTwo.append(trCost, trDays, trName, trLastname);
	tableTwo.append(tbodyTwo);

	return [tableOne, tableTwo];
}
function createTouristTable (tourist, index) {
	const table = document.createElement('table');
	const tbody = document.createElement('tbody');
	const [trParticipant, trFullName, trBirthday, trPassport,] = (new Array(4)).fill(0)
		.map(_ => document.createElement('tr'));
	const [tdParticipantLabel, tdParticipant, tdFullNameLabel, tdFullName, tdBirthdayLabel, tdBirthday, tdPassportLabel, tdPassport,] = (new Array(8)).fill(0)
		.map(_ => document.createElement('td'));

	tdParticipantLabel.textContent = `${labels.participant} №${index + 1}`;
	trParticipant.append(tdParticipantLabel, tdParticipant);
	tdFullNameLabel.textContent = labels.fullName;
	tdFullName.textContent = `${tourist.name} ${tourist.lastname}`;
	trFullName.append(tdFullNameLabel, tdFullName);
	tdBirthdayLabel.textContent = labels.birthday;
	tdBirthday.textContent = tourist.birthday;
	trBirthday.append(tdBirthdayLabel, tdBirthday);
	tdPassportLabel.textContent = labels.passport;
	tdPassport.textContent = tourist.passport;
	trPassport.append(tdPassportLabel, tdPassport);
	tbody.append(trParticipant, trFullName, trBirthday, trPassport);
	table.append(tbody);

	return table;
}
function  showPolicyShortDetails ({ infoBlockClass, infoDetailsClass }, body) {
	const modifier = '--active';
	const infoBlock = document.getElementsByClassName(infoBlockClass)[0];
	const detailsBlock = document.getElementsByClassName(infoDetailsClass)[0];

	if (!infoBlock || !detailsBlock) {
		return;
	}

	removeClassFromElement(infoBlock, infoBlockClass, modifier);
	detailsBlock.innerHTML = '';
	detailsBlock.append(...createDetailsTables(body));
	addClassToElement(infoBlock, infoBlockClass, modifier);
}
// function createPolicyDetails (policy, downloadAttributeName) {
// 	const title = document.createElement('h4');
// 	const [spanOne, spanTwo, spanButton] = (new Array(3)).fill(0)
// 		.map(_ => document.createElement('span'));
// 	const policyWrapper = document.createElement('div');
// 	const button = document.createElement('button');
// 	const img = document.createElement('img');
// 	const [tableDetails, tableInsurer] = (new Array(2)).fill(0)
// 		.map(_ => document.createElement('table'));
// 	const [tbodyDetails, tbodyInsurer] = (new Array(2)).fill(0)
// 		.map(_ => document.createElement('tbody'));
// 	const [trGeneral, trStart, trExpiration, trDays, trTerritory, trDeductible, trInsurer, trFullName, trBirthday, trPhone, trEmail,] = (new Array(11)).fill(0)
// 		.map(_ => document.createElement('tr'));
// 	const [tdGeneralLabel, tdGeneral, tdStartLabel, tdStart, tdExpirationLabel, tdExpiration, tdDaysLabel, tdDays, tdTerritoryLabel, tdTerritory, tdDeductibleLabel, tdDeductible, tdInsurerLabel, tdInsurer, tdFullNameLabel, tdFullName, tdBirthdayLabel, tdBirthday, tdPhoneLabel, tdPhone, tdEmailLabel, tdEmail,] = (new Array(22)).fill(0)
// 		.map(_ => document.createElement('td'));
//
// 	spanOne.textContent = labels.title;
// 	spanTwo.textContent = `№${policy.id || policy.policy_number}`;
// 	title.append(spanOne, spanTwo);
// 	tdGeneralLabel.textContent = labels.general;
// 	trGeneral.append(tdGeneralLabel, tdGeneral);
// 	tdStartLabel.textContent = labels.start;
// 	tdStart.textContent = policy.details.start;
// 	trStart.append(tdStartLabel, tdStart);
// 	tdExpirationLabel.textContent = labels.expiration;
// 	tdExpiration.textContent = policy.details.end;
// 	trExpiration.append(tdExpirationLabel, tdExpiration);
// 	tdDaysLabel.textContent = labels.days;
// 	tdDays.textContent = policy.details.days;
// 	trDays.append(tdDaysLabel, tdDays);
// 	tdTerritoryLabel.textContent = labels.territory;
// 	tdTerritory.textContent = policy.details.territory;
// 	trTerritory.append(tdTerritoryLabel, tdTerritory);
// 	tdDeductibleLabel.textContent = labels.deductible;
// 	tdDeductible.textContent = policy.details.deductible;
// 	trDeductible.append(tdDeductibleLabel, tdDeductible);
// 	tbodyDetails.append(trGeneral, trStart, trExpiration, trDays, trTerritory, trDeductible);
// 	tableDetails.append(tbodyDetails);
// 	tdInsurerLabel.textContent = labels.insurer;
// 	trInsurer.append(tdInsurerLabel, tdInsurer);
// 	tdFullNameLabel.textContent = labels.fullName;
// 	tdFullName.textContent = `${policy.insurer.name} ${policy.insurer.lastname}`;
// 	trFullName.append(tdFullNameLabel, tdFullName);
// 	tdBirthdayLabel.textContent = labels.birthday;
// 	tdBirthday.textContent = policy.insurer.birthday;
// 	trBirthday.append(tdBirthdayLabel, tdBirthday);
// 	tdPhoneLabel.textContent = labels.phone;
// 	tdPhone.textContent = policy.insurer.phone;
// 	trPhone.append(tdPhoneLabel, tdPhone);
// 	tdEmailLabel.textContent = labels.email;
// 	tdEmail.textContent = policy.insurer.email;
// 	trEmail.append(tdEmailLabel, tdEmail);
// 	tbodyInsurer.append(trInsurer, trFullName, trBirthday, trPhone, trEmail);
// 	tableInsurer.append(tbodyInsurer);
// 	policyWrapper.classList.add(classes.wrapperClass);
// 	policyWrapper.append(tableDetails, tableInsurer);
// 	policy.tourists.forEach((tourist, idx) => {
// 		policyWrapper.append(createTouristTable(tourist, idx));
// 	});
//
// 	if (policy.token) {
// 		img.src = labels.src;
// 		spanButton.textContent = labels.button;
// 		button.classList.add(classes.buttonClass);
// 		button.setAttribute('type', 'button');
// 		button.setAttribute(downloadAttributeName, policy.token);
// 		button.append(img, spanButton);
// 	}
//
// 	return policy.token ? [title, policyWrapper, button] :  [title, policyWrapper];
// }
function createPolicyDetails (policy) {
	const [tableDetails, tableInsurer] = (new Array(2)).fill(0)
		.map(_ => document.createElement('table'));
	const [tbodyDetails, tbodyInsurer] = (new Array(2)).fill(0)
		.map(_ => document.createElement('tbody'));
	const [trGeneral, trStart, trExpiration, trDays, trTerritory, trDeductible, trInsurer, trFullName, trBirthday, trPhone, trEmail,] = (new Array(11)).fill(0)
		.map(_ => document.createElement('tr'));
	const [tdGeneralLabel, tdGeneral, tdStartLabel, tdStart, tdExpirationLabel, tdExpiration, tdDaysLabel, tdDays, tdTerritoryLabel, tdTerritory, tdDeductibleLabel, tdDeductible, tdInsurerLabel, tdInsurer, tdFullNameLabel, tdFullName, tdBirthdayLabel, tdBirthday, tdPhoneLabel, tdPhone, tdEmailLabel, tdEmail,] = (new Array(22)).fill(0)
		.map(_ => document.createElement('td'));

	tdGeneralLabel.textContent = labels.general;
	trGeneral.append(tdGeneralLabel, tdGeneral);
	tdStartLabel.textContent = labels.start;
	tdStart.textContent = policy.details.start;
	trStart.append(tdStartLabel, tdStart);
	tdExpirationLabel.textContent = labels.expiration;
	tdExpiration.textContent = policy.details.end;
	trExpiration.append(tdExpirationLabel, tdExpiration);
	tdDaysLabel.textContent = labels.days;
	tdDays.textContent = policy.details.days;
	trDays.append(tdDaysLabel, tdDays);
	tdTerritoryLabel.textContent = labels.territory;
	tdTerritory.textContent = policy.details.territory;
	trTerritory.append(tdTerritoryLabel, tdTerritory);
	tdDeductibleLabel.textContent = labels.deductible;
	tdDeductible.textContent = policy.details.deductible;
	trDeductible.append(tdDeductibleLabel, tdDeductible);
	tbodyDetails.append(trGeneral, trStart, trExpiration, trDays, trTerritory, trDeductible);
	tableDetails.append(tbodyDetails);
	tdInsurerLabel.textContent = labels.insurer;
	trInsurer.append(tdInsurerLabel, tdInsurer);
	tdFullNameLabel.textContent = labels.fullName;
	tdFullName.textContent = `${policy.insurer.name} ${policy.insurer.lastname}`;
	trFullName.append(tdFullNameLabel, tdFullName);
	tdBirthdayLabel.textContent = labels.birthday;
	tdBirthday.textContent = policy.insurer.birthday;
	trBirthday.append(tdBirthdayLabel, tdBirthday);
	tdPhoneLabel.textContent = labels.phone;
	tdPhone.textContent = policy.insurer.phone;
	trPhone.append(tdPhoneLabel, tdPhone);
	tdEmailLabel.textContent = labels.email;
	tdEmail.textContent = policy.insurer.email;
	trEmail.append(tdEmailLabel, tdEmail);
	tbodyInsurer.append(trInsurer, trFullName, trBirthday, trPhone, trEmail);
	tableInsurer.append(tbodyInsurer);

	return [tableDetails, tableInsurer, ...policy.tourists.map(createTouristTable)];
}
// function  showPolicyFullDetails ({ policyBlockClass }, body) {
// 	const modifier = '--active';
// 	const policyBlock = document.getElementsByClassName(policyBlockClass)[0];
// 	const { policy_number, details, insurer, tourists, token } = body;
//
// 	if (!policyBlock) {
// 		return
// 	}
//
// 	removeClassFromElement(policyBlock, policyBlockClass, modifier);
// 	policyBlock.innerHTML = '';
//
// 	const detailsElements = createPolicyDetails({
// 		policy_number, details, insurer, tourists, token
// 	}, 'data-send-policy');
// 	const sendForm = createSendPolicyToEmailForm({policyBlockClass}, body);
//
// 	policyBlock.append(...detailsElements, sendForm);
// 	addClassToElement(policyBlock, policyBlockClass, modifier);
// }
function  showPolicyFullDetails ({ policyBlockClass }, body) {
	const modifier = '--active';
	const policyBlock = document.getElementsByClassName(policyBlockClass)[0];
	const { policy_number, details, insurer, tourists, token } = body;

	if (!policyBlock) {
		return;
	}

	const wrapperBlock = document.getElementsByClassName(policyBlockClass + '-wrapper')[0];

	if (!wrapperBlock) {
		return;
	}

	removeClassFromElement(policyBlock, policyBlockClass, modifier);
	wrapperBlock.innerHTML = '';
	wrapperBlock.append(...createPolicyDetails({ details, insurer, tourists }));
	updatePolicyFullDetailsTitle('№' + policy_number);
	updatePolicyFullDetailsAttribute('data-token', token);
	// updatePolicyFullDetailsAttribute('data-id', policy_number);
	addClassToElement(policyBlock, policyBlockClass, modifier);
}
function setIntroFormHandlers() {
	const introForm = document.getElementsByClassName('intro__form')[0];

	if (!introForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'intro__form-group' });
	const hideInputError = hideError({ groupClass: 'intro__form-group' });
	const showInputSuccess = showSuccess({ groupClass: 'intro__form-group' });
	const hideInputSuccess = hideSuccess({ groupClass: 'intro__form-group' });
	const tags = [ 'INPUT', 'TEXTAREA' ];

	for (const element of introForm.elements) {
		const { tagName } = element;

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('focus', hideInputSuccess);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);
		}
	}

	introForm.addEventListener('submit', (e) => {
		e.preventDefault();
		const body = validateForm(e.target);

		resetInfoBlock();
		resetFullInfoBlock();

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({ target: input }));

			return;
		}

		sendRequestAndSaveToken('/api/check_policy', {
			method: 'POST', body: JSON.stringify({ order_id: body.policy_number })
		}).then(({ response }) => {
			if (!response || !response.success) {
				const groupClass = 'intro__form-group';
				const selector = '.' + groupClass + '>input[name="policy_number"]';
				const groupElement = document.querySelector(selector).parentElement;

				addClassToElement(groupElement, groupClass, '--error');

				return;
			}

			// const {data} = response;
			const { policy_number } = body;
			// const fakeData = {
			// 	start: '2023-08-17',
			// 	end: '2024-08-15',
			// 	status: 'Paid',
			// 	program: 'A',
			// 	price: 1900,
			// 	days: '365',
			// 	currency: 'USD',
			// 	name: "ROMA****",
			// 	lastname: 'ROMA*******'
			// };

			showInputSuccess({target: e.submitter.previousElementSibling});
			showPolicyShortDetails({
				infoBlockClass: 'info', infoDetailsClass: 'info__details',
			}, response);
			infoForm.dataset['id'] = policy_number.toString();
		}).catch(e => {
			console.log(e.message);
			showModalById('error-modal');
		});
	});
}
function setInfoFormHandlers() {
	if (!infoForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'info__form-group' });
	const showInputSuccess = showSuccess({ groupClass: 'info__form-group' });
	const tags = [ 'INPUT', 'TEXTAREA' ];

	for (const element of infoForm.elements) {
		const { tagName, name } = element;

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideInfoFormInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('focus', hideInfoFormInputSuccess);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);


			if (['passport'].includes(name)) {
				element.addEventListener('input', modifyValueToUpperCase);
			}
		}
	}

	infoForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const body = validateForm(e.target);

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({ target: input }));

			return;
		}

		resetFullInfoBlock();

		const policy_number = infoForm.dataset['id'] || '';

		sendRequestAndSaveToken('/api/check_passport', {
			method: 'POST', body: JSON.stringify({ passport: body.passport, order_id: policy_number })
		}).then(({ response }) => {
			if (!response || !response.success) {
				const groupClass = 'info__form-group';
				const selector = '.' + groupClass + '>input[name="passport"]';
				const groupElement = document.querySelector(selector).parentElement;

				addClassToElement(groupElement, groupClass, '--error');

				return;
			}

			const {data} = response;
			// const fakeData = {
			// 	download_link: 'https://www.google.com/',
			// 	policy_number,
			// 	details: {
			// 		start: '17.08.2022',
			// 		end: '14.08.2024',
			// 		days: '365',
			// 		territory: 'Italy',
			// 		deductible: '0 USD',
			// 	},
			// 	insurer: {
			// 		name: 'Max',
			// 		lastname: 'White',
			// 		birthday: '11.09.1987',
			// 		passport: 'ps12321',
			// 		phone: '+39 094 909 44 90',
			// 		email: 'user.name@gmail.com',
			// 	},
			// 	tourists: [
			// 		{
			// 			name: 'Jenny',
			// 			lastname: 'Wilson',
			// 			birthday: '23.01.2001',
			// 			passport: 'FA 12345',
			// 		},
			// 	],
			// }
			const fakeData = {
				...response,
				policy_number,
			};

			showInputSuccess({target: e.submitter.previousElementSibling});
			showPolicyFullDetails({policyBlockClass: 'info__policy'}, fakeData);
		}).catch(e => {
			console.log(e.message);
			showModalById('error-modal');
		})
	});
}
function setSendPolicyFormHandlers() {
	if (!sendPolicyForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'info__policy-form-group' });
	const tags = [ 'INPUT', 'TEXTAREA' ];

	for (const element of sendPolicyForm.elements) {
		const { tagName } = element;

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideSendFormInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);
		}
	}

	sendPolicyForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const body = validateForm(e.target);

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({target: input}));

			return;
		}

		const { id, token } = e.submitter.dataset;
		const { email } = body;

		if (!token) {
			return;
		}

		sendRequestAndSaveToken('/api/send_policy', {
			method: 'POST', body: JSON.stringify({ email, token })
		}).then(({ response }) => {
			if (!response || !response.success) {
				showModalById('error-modal');

				return;
			}

			showModalById('success-sent-modal');
			console.log(response);
		}).catch(e => {
			showModalById('error-modal');
			console.error(e.message);
		})
	});
}



// function createSendPolicyToEmailForm ({policyBlockClass}, policy) {
//
// 	// <form action="" className="info__policy-form">
// 	// 	<div className="info__policy-form-group">
// 	// 		<label htmlFor="email"><?= lang('Validation.modal_form_email_label') ?></label>
// 	// 		<input name="email" type="email" placeholder="<?= lang('Validation.modal_form_email_placeholder') ?>"/>
// 	// 		<p><?= lang('Validation.modal_form_email_error') ?></p>
// 	// 	</div>
// 	// 	<button aria-label="Send policy to Email"
// 	// 			className="info__policy-form-button"><?= lang('Validation.button_send') ?>
// 	// 	</button>
// 	// </form>
//
// 	const form = document.createElement('form');
// 	const formGroup = document.createElement('div');
// 	const label = document.createElement('label');
// 	const input = document.createElement('input');
// 	const errorP = document.createElement('p');
// 	const button = document.createElement('button');
//
// 	label.textContent = labels.labelEmail;
// 	input.setAttribute('name', 'email');
// 	input.setAttribute('type', 'email');
// 	input.setAttribute('placeholder', labels.placeholderEmail);
// 	input.setAttribute('data-placeholder', labels.placeholderEmail);
// 	input.addEventListener('focus', hideSendFormInputError);
// 	input.addEventListener('focus', hidePlaceholder);
// 	input.addEventListener('blur', checkSendFormInputValue);
// 	input.addEventListener('blur', showPlaceholder);
// 	errorP.textContent = labels.errorEmail;
// 	formGroup.classList.add(policyBlockClass + '-form-group');
// 	formGroup.append(label, input, errorP);
// 	button.setAttribute('aria-label', 'Send policy to Email');
// 	button.setAttribute('data-token', policy.token);
// 	button.textContent = labels.buttonSend;
// 	button.classList.add(policyBlockClass + '-form-button');
// 	form.action = '';
// 	form.classList.add(policyBlockClass + '-form');
// 	form.append(formGroup, button);
// 	form.addEventListener('submit', sendPolicyToEmailFormSubmitHandler);
//
// 	return form;
// }

// function removeSendPolicyToEmailFormListeners(form) {
// 	for (const element of form.elements) {
// 		const { tagName } = element;
// 		const tags = [ 'INPUT', 'TEXTAREA' ];
//
// 		if (tags.includes(tagName)) {
// 			savePlaceholder(element);
// 			element.removeEventListener('focus', hideSendFormInputError);
// 			element.removeEventListener('focus', hidePlaceholder);
// 			element.removeEventListener('blur', checkSendFormInputValue);
// 			element.removeEventListener('blur', showPlaceholder);
// 		}
// 	}
//
// 	form.removeEventListener('submit', sendPolicyToEmailFormSubmitHandler);
// }

// function sendPolicyToEmailFormSubmitHandler (e) {
// 	e.preventDefault();
// 	const body = validateForm(e.target);
//
// 	if (!body.isValid) {
// 		body.errorInputs.forEach(input => checkSendFormInputValue({target: input}));
//
// 		return;
// 	}
//
// 	const { token } = e.submitter.dataset;
//
// 	if (!token) {
// 		return;
// 	}
//
// 	console.log(body);
// 	console.log(e);
//
// 	// sendRequestAndSaveToken('/api/send_policy', {
// 	// 	method: 'POST', body: JSON.stringify({ token: sendPolicy })
// 	// }).then(({ response }) => {
// 	// 	if (!response || !response.success) {
// 	// 		showModalById('error-modal');
// 	//
// 	// 		return;
// 	// 	}
// 	//
// 	// 	showModalById('success-modal');
// 	// 	console.log(response);
// 	// }).catch(e => {
// 	// 	showModalById('error-modal');
// 	// 	console.error(e.message);
// 	// })
// }

function updatePolicyFullDetailsTitle (title = '') {
	const policyDetailsWrapper = document.getElementsByClassName('info__policy')[0];

	if (!policyDetailsWrapper) {
		return;
	}

	const titleLabel = policyDetailsWrapper.firstElementChild.lastElementChild;

	if (!titleLabel) {
		return;
	}

	titleLabel.textContent = title;
}

function updatePolicyFullDetailsAttribute (attributeName, value = '') {
	const sendPolicyFormButton = document.getElementsByClassName('info__policy-form-button')[0];

	if (!sendPolicyFormButton) {
		return;
	}

	sendPolicyFormButton.setAttribute(attributeName, value);
}

function resetInfoBlock () {
	const modifier = '--active';
	const infoBlockClass = 'info';
	const infoBlock = document.getElementsByClassName(infoBlockClass)[0];
	const detailsBlock = document.getElementsByClassName(infoBlockClass + '__details')[0];
	const tags = [ 'INPUT', 'TEXTAREA' ];

	if (!infoBlock || !detailsBlock) {
		return;
	}

	removeClassFromElement(infoBlock, infoBlockClass, modifier);
	detailsBlock.innerHTML = '';
	infoForm.reset();

	for (const element of infoForm.elements) {
		const { tagName, name } = element;

		if (tags.includes(tagName)) {
			hideInfoFormInputSuccess({ target: element });
			hideInfoFormInputError({ target: element });
			showPlaceholder({ target: element });
		}
	}
}

function resetFullInfoBlock () {
	const modifier = '--active';
	const policyBlockClass = 'info__policy';
	const policyBlock = document.getElementsByClassName(policyBlockClass)[0];

	if (!policyBlock) {
		return;
	}

	const wrapperBlock = document.getElementsByClassName(policyBlockClass + '-wrapper')[0];
	const tags = [ 'INPUT', 'TEXTAREA' ];

	if (!wrapperBlock) {
		return;
	}

	removeClassFromElement(policyBlock, policyBlockClass, modifier);
	wrapperBlock.innerHTML = '';
	updatePolicyFullDetailsTitle();
	updatePolicyFullDetailsAttribute('data-token');
	// updatePolicyFullDetailsAttribute('data-id');
	sendPolicyForm.reset();

	for (const element of sendPolicyForm.elements) {
		const { tagName, name } = element;

		if (tags.includes(tagName)) {
			hideSendFormInputError({ target: element });
			showPlaceholder({ target: element });
		}
	}
}

function getProgramNameById(id) {
	const programNames = {
		'3': labels.tariffLabelMax,
		'6': labels.tariffLabelStart,
		'11': labels.tariffLabelGold,
	};

	return programNames[id.toString()] || '-';
}

function createStatusSpan (text) {
	const successColor = '#03812E';
	const errorColor = '#dc0000';
	const successTextArray = [
		'paid',
		'active',
	];
	const span = document.createElement('span');
	const isSuccess = successTextArray.includes(text.toLowerCase());

	span.style.color = successTextArray.includes(text.toLowerCase()) ? successColor : errorColor;
	span.textContent = text;

	return span;
}


function modifyValueToUpperCase (e) {
	// const { target } = e;

	// target.value = target.value.toUpperCase();
	let value_arr = this.value.split('');
	this.value = value_arr.map(item => item.toUpperCase()).join('')
}

}init();